/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_SizeInputs */

const en_admin_resources_resource_allocations_size = /** @type {(inputs: Admin_Resources_Resource_Allocations_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

const de_admin_resources_resource_allocations_size = /** @type {(inputs: Admin_Resources_Resource_Allocations_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe`)
};

const es_admin_resources_resource_allocations_size = /** @type {(inputs: Admin_Resources_Resource_Allocations_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño`)
};

const fr_admin_resources_resource_allocations_size = /** @type {(inputs: Admin_Resources_Resource_Allocations_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille`)
};

const nl_admin_resources_resource_allocations_size = /** @type {(inputs: Admin_Resources_Resource_Allocations_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grootte`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_SizeInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_size = en_admin_resources_resource_allocations_size;

/** @type {(inputs: Admin_Resources_Resource_Allocations_SizeInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_size = en_admin_resources_resource_allocations_size;

/** @type {(inputs: Admin_Resources_Resource_Allocations_SizeInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_size = en_admin_resources_resource_allocations_size;

/** @type {(inputs: Admin_Resources_Resource_Allocations_SizeInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_size = en_admin_resources_resource_allocations_size;

/** @type {(inputs: Admin_Resources_Resource_Allocations_SizeInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_size = en_admin_resources_resource_allocations_size;

/**
* | output |
* | --- |
* | "Size" |
*
* @param {Admin_Resources_Resource_Allocations_SizeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_size = /** @type {((inputs?: Admin_Resources_Resource_Allocations_SizeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_SizeInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_size(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_size(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_size(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_size(inputs)
	if (locale === "nl") return nl_admin_resources_resource_allocations_size(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_size(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_size(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_size(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_size(inputs)
	return ro_admin_resources_resource_allocations_size(inputs)
});
export { admin_resources_resource_allocations_size as "admin.resources.resource_allocations.size" }